// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bc9fa4fb","710":"98a8296a"}[chunkId] + ".chunk.js";
};